<template lang="">
    <div
        style="width: 100%; height: 90vh; float: left; padding-right: 5px"
        ref="plotagempdfdiv">
            <template>
                <v-row justify="center">
                    <v-dialog v-model="progressoDialog" persistent
                    max-width="500" style="height: 300px; z-index: 90000"
                    >
                    <v-card>
                        <v-card-text>
                        <v-row justify="center">
                            <h3 style="margin-top: 20px; color: #1565c0">
                            {{ this.mensagemProgressoDialog }}
                            </h3>
                        </v-row>

                        <v-row justify="center">
                            <v-progress-circular :size="50" :width="5" color="primary"
                            indeterminate style="margin-top: 10px; margin-bottom: 10px" ></v-progress-circular>
                        </v-row>
                        </v-card-text>
                    </v-card>
                    </v-dialog>
                </v-row>
            </template>

<v-navigation-drawer v-model="showingDrawer" absolute overlay-opacity="0" temporary left dark
    style="width: 35%; z-index: 10000" @transitionend="drawerTransition">
    <v-container class="white--text" style="padding-left: 20px">
        <v-row>
            <h1 style='margin-top: 5px;'>{{ $t('mapaPlotagem.details.title') }}</h1>
            <v-spacer></v-spacer>
            <v-btn small fab @click="exportPDF($refs.plotagempdfdiv)" style="margin:  5px 5px 0 0">
                <v-icon color="white">mdi-file-pdf-box</v-icon></v-btn>
        </v-row>
        <hr style="border-top: 1px solid #fff; margin-top: 15px" />
        <br />
        <pre>{{ $t('mapaPlotagem.details.vehicle') }} : {{ posicaoMarkerClicked?.cod_veiculo }}</pre>
        <pre>{{ $t('mapaPlotagem.details.order') }} : {{ posicaoMarkerClicked?.numero_ordem }}</pre>
        <pre>{{ $t('mapaPlotagem.details.date') }} : {{ posicaoMarkerClicked?.dt_posicao_extenso }}</pre>
        <pre>{{ $t('mapaPlotagem.details.latitude') }} : {{ posicaoMarkerClicked?.lat }}</pre>
        <pre>{{ $t('mapaPlotagem.details.longitude') }} : {{ posicaoMarkerClicked?.lng }}</pre>
        <pre>{{ $t('mapaPlotagem.details.heading') }} : {{ posicaoMarkerClicked?.rumo }}</pre>
        <pre>{{ $t('mapaPlotagem.details.speed') }} : {{ posicaoMarkerClicked?.velocidade }}</pre>
        <pre>{{ $t('mapaPlotagem.details.direction') }} : {{ posicaoMarkerClicked?.sentido_extenso }}</pre>
        <pre>{{ $t('mapaPlotagem.details.integrationCode') }} : {{ posicaoMarkerClicked?.cod_integracao }}</pre>
        <pre>{{ $t('mapaPlotagem.details.equipment') }} : {{ posicaoMarkerClicked?.cod_equipamento }}</pre>
        <br />
        <h3>{{ $t('mapaPlotagem.details.address') }}</h3>
        <hr style="border-top: 1px solid #fff" />
        <pre>{{ $t('mapaPlotagem.details.street') }} : {{ itemEndereco[0].street }}</pre>
        <pre>{{ $t('mapaPlotagem.details.number') }} : {{ itemEndereco[0].houseNumber }}</pre>
        <pre>{{ $t('mapaPlotagem.details.district') }} : {{ itemEndereco[0].district }}</pre>
        <pre>{{ $t('mapaPlotagem.details.city') }} : {{ itemEndereco[0].city }}</pre>
        <pre>{{ $t('mapaPlotagem.details.state') }} : {{ itemEndereco[0].stateCode }}</pre>
        <pre>{{ $t('mapaPlotagem.details.postalCode') }} : {{ itemEndereco[0].postalCode }}</pre>

        <hr style="border-top: 1px solid #fff" />
        <br />
        <v-btn color="primary" class="white--text" style="margin-left: 5px; margin-right: 5px" @click="
                  obterEnderecoMarkerPlotagem(
                    posicaoMarkerClicked?.lat,
                    posicaoMarkerClicked?.lng,
                    null
                  )
                ">
            {{ $t('mapaPlotagem.details.getAddress') }}
        </v-btn>

        <v-progress-circular indeterminate v-if="showProgressEndereco" color="primary"
            style="margin-left: 20px"></v-progress-circular>
    </v-container>

    <v-container class="white--text" style="padding-left: 20px">
        <h3>{{$t('mapaPlotagem.details.reproduction')}}</h3>
        <hr style="border-top: 1px solid #fff" />
        <br />

        <v-row justify="center" style="margin-top: 5px;">
            <v-col cols="12" sm="12" md="8" align="end">
                <v-select :items="velocidades" item-text="texto" item-value="valor" v-model="playSpeed"
                    prepend-icon="mdi-car-speed-limiter" :label="$t('mapaPlotagem.controls.playbackSpeed')" dense>
                </v-select>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="2" align="end">
                <v-btn color="primary" class="white--text" style="margin-left: 5px; margin-right: 5px" fab small
                    @click="startReplay" :disabled="startReplayDisabled">
                    <v-icon>mdi-play</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="3" md="2" align="end">
                <v-btn color="primary" class="white--text" style="margin-left: 5px; margin-right: 5px" fab small
                    @click="stopReplay" :disabled="stopReplayDisabled">
                    <v-icon>mdi-stop</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="3" md="2" align="end">
                <v-btn color="primary" class="white--text" style="margin-left: 5px; margin-right: 5px" fab small
                    @click="navegaPosicoes('anterior')" :disabled="navegaPosicaoAnteriorDisabled">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="3" md="2" align="end">
                <v-btn color="primary" class="white--text" style="margin-left: 5px; margin-right: 5px" fab small
                    @click="navegaPosicoes('posterior')" :disabled="navegaPosicaoPosteriorDisabled">
                    <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end" style="margin-right: 10px; margin-top: 15px;">
            <v-btn color="primary" dark @click="sincronizarPosicoes" :disabled="sincronizarDisabled">
                {{$t('mapaPlotagem.details.syncronize')}}
            </v-btn>
        </v-row>
    </v-container>
</v-navigation-drawer>

<l-map ref="mapPlotagem" :zoom="zoom" :center="currentCenter" @update:center="centerUpdate" @update:zoom="zoomUpdate"
    @ready="onMapPlotagemResize" :options="mapOptions" v-resize="onMapPlotagemResize"
    style="border-radius: 10px; margin-top: 5px; z-index: 1">
    <l-tile-layer :url="url" :attribution="attribution" />

    <l-marker :key="j" v-for="(reg, j) in bilhetagensCarro" :lat-lng="latLng(reg.lat, reg.lng)"
        :visible="markerBilhetagensVisible" :icon="getIconBilhetagem()">
        <l-popup :options="{ maxWidth: 'fit-content'}">
            <pre>{{$t('mapaPlotagem.date')}} : {{ reg.dt_posicao_extenso }}</pre>
            <pre>{{$t('mapaPlotagem.latitude')}} : {{ reg.lat }}</pre>
            <pre>{{$t('mapaPlotagem.longitude')}} : {{ reg.lng }}</pre>
        </l-popup>
    </l-marker>

    <l-marker v-for="(r, i) in pontosInteresse" :key="`${r.id_cerca}-${i}`"
        :lat-lng="latLng(r.lat_centro, r.lng_centro)" :visible="showPontosInteresse">
        <l-popup :options="{ maxWidth: 'fit-content'}">
            <pre>{{$tc('geofence.self', 1)}} : {{ r.nome_cerca }}</pre>
            <pre>{{$t('tripOperation.type')}} : {{ r.descricao_tipo_cerca }}</pre>
            <pre>{{$tc('address.self', 1)}} : {{ r.endereco }}</pre>
        </l-popup>
    </l-marker>

    <l-geo-json v-for="(reg, w) in pontosInteresse" :key="`POI-${reg.id_cerca}-${w}`" :geojson="reg.geojson"
        :options="reg.options" :options-style="reg.style" :visible="showPontosInteresse">
    </l-geo-json>

    <l-geo-json v-for="(rota, i) in filteredRotas" :key="`$ROTA-${i}`" :geojson="rota.geojson"
        :options-style="rota.style" :options="rota.options" :visible="showRotas">
    </l-geo-json>

    <l-geo-json v-for="(reg, w) in cercasGeojson" :key="`CERCA-${reg.id_cerca}-${w}`" :geojson="reg.geojson"
        :options="reg.options" :options-style="reg.style" :visible="showCercas && reg.visible">
    </l-geo-json>

            <l-circle
                v-for="(reg, w) in cercasCircularesIda"
                :key="`CIRCULAR-IDA-${reg.id_cerca}-${w}`"
                :lat-lng="latLng(reg.lat_centro, reg.lng_centro)"
                :radius="reg.raio_mts"
                :visible="showCercas && showIda && reg.visible"
            >
                <l-tooltip :content="reg.nome_cerca"></l-tooltip>
            </l-circle>

            <l-circle
                v-for="(reg, w) in cercasCircularesVolta"
                :key="`CIRCULAR-VOLTA-${reg.id_cerca}-${w}`"
                :lat-lng="latLng(reg.lat_centro, reg.lng_centro)"
                :radius="reg.raio_mts"
                :visible="showCercas && showVolta && reg.visible"
            >
                <l-tooltip :content="reg.nome_cerca"></l-tooltip>
            </l-circle>

            <Vue2LeafletRotatedMarker
                v-for="(reg, k) in posicoesCarroFiltered"
                :key="`${reg.id_carro}-${reg._index != null ? reg._index : k}`"
                :lat-lng="latLng(reg.lat, reg.lng)"
                :visible="markerPosicoesVisible && (reg.id_linha === idLinhaSelected || idLinhaSelected === null)"
                :icon="getIconPosicao(reg)"
                @click="showDetalhesPosicoes(getOriginalIndex(reg))"
                :rotationAngle="getMarkerRotation(reg)"
                :rotationOrigin="'15px 15px'"
                :zIndexOffset="getZIndexOffset(reg)"
                >
            </Vue2LeafletRotatedMarker>

    <l-control :position="'topright'" class="text-overlay">
        <v-row>
            <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="showRotas" :label="$tc('operation.route', 1)"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="showCercas" :label="$tc('geofence.self', 1)"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="showPontosInteresse" :label="$t('operation.pois')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="markerPosicoesVisible" :label="$t('relMaintenence.positions')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="markerBilhetagensVisible" :label="$t('notificationMap.ticketing')"></v-checkbox>
            </v-col>
        </v-row>
    </l-control>

    <l-control :position="'topright'" class="text-overlay">
        <v-row>
            <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="showIda" :label="$t('operation.go')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="showVolta" :label="$t('operation.back')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="showDeslocamento" :label="$t('operation.deadhead')"></v-checkbox>
            </v-col>
        </v-row>
    </l-control>

            <l-control :position="'topright'">
                <v-autocomplete
                    v-model="idLinhaSelected"
                    :items="linhasSelect"
                    item-text="cod_linha"
                    item-value="id_linha"
                    :label="$t('mapaPlotagem.controls.line')"
                    solo
                    clearable
                    @change="linhaChanged"
              ></v-autocomplete>
            </l-control>

    <l-control :position="'topright'">
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                    <v-btn small fab @click="exportPDF($refs.plotagempdfdiv)" v-on="on">
                        <v-icon color="black">mdi-file-pdf-box</v-icon></v-btn
                    >
                </template>
            <div>{{ $t('system.labels.exportToPdf') }}</div>
        </v-tooltip>

    </l-control>

    <l-control :position="'topright'">
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                    <v-btn small fab @click="exportTable()" v-on="on" :disabled="posicoesCarro.length > 100">
                      <v-icon color="black">mdi-file-document-edit</v-icon></v-btn
                    >
                </template>
            <div>
                <div>{{$t('mapaPlotagem.exportToTable')}}</div>
                <div>{{$t('mapaPlotagem.anotherAddress')}}: {{ 30000 - parametrosControle.chamadas_here_api }}</div>
            </div>
        </v-tooltip>
    </l-control>
</l-map>
</div>
</template>
<script>
import axios from "axios";
import apiController from "@/utils/apiController";
import { RevGeoCodeBaseUrl, GeoCodeBatchUrl, GeoCodeApiKey } from "@/constants";
import EventBus from "@/utils/eventBus";
import registrarChamadaApiExterna from "@/utils/registrarChamadaApiExterna";
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LGeoJson,
  LCircle,
  LTooltip,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import DateUtils from "../utils/dateutils";
import autoTable from "jspdf-autotable";

export default {
    name: "MapaPlotagem",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LControl,
        LGeoJson,
        Vue2LeafletRotatedMarker,
        LCircle,
        LTooltip,
    },
    props: {
        dti: {
            type: String,
            default() {
                return this.today + "000000";
            }
        },
        dtf: {
            type: String,
            default() {
                return this.today + "235959";
            }
        },
        idVeiculo: {
            type: Array,
        },
        posicoes: {
            type: Array,
        },
        user: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            required: true
        }
    },
    data: () => ({
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        apikey: "QeQ6E6MO3W67BFddkL_xppXuMF8dF1Biy6Dy8XhOPVE",
        mensagemProgressoDialog: "",
        progressoDialog: false,
        showingDrawer: false,
        posicaoMarkerClicked: null,
        showProgressEndereco: false,
        itemEndereco: [
            {
                street: "",
                houseNumber: "",
                district: "",
                city: "",
                stateCode: "",
                postalCode: "",
            }],
        zoom: 12,
        currentZoom: 11.5,
        currentCenter: [-22.88746, -43.29185],
        mapOptions: {
            zoomSnap: 0.5,
        },
        markerPosicoesVisible: false,
        bilhetagensCarro: [],
        markerBilhetagensVisible: false,
        pontosInteresse: [],
        showPontosInteresse: false,
        showRotas: false,
        showCercas: false,
        showIda: true,
        showVolta: true,
        showDeslocamento: false,
        cercas: [],
        posicoesCarro: [],
        linhasSelect: [],
        rotas: [],
        indexPosicaoClicked: null,
        indexPosicaoSincronizada: null,
        ultimaPosicaoClicked: null,
        idLinhaSelected: null,
        playing: false,
        playSpeed: 1,
        polyLine: {
            latlngs: [],
            color: "red",
        },
        lineColors: [
            "red",
            "blue",
            "green",
            "purple",
            "yellow",
            "orange",
            "brown",
            "black"
        ],
        platform: null,
        parametrosControle: {
            chamadas_here_api: 0,
        },
        /** Cache de L.divIcon para evitar recriar SVG a cada re-render. */
        iconCache: Object.create(null),
    }),
    computed: {
        center() {
            return this.$store.getters['config/centerDefault'];
        },
        velocidades() {
            return [
                { texto: this.$t('mapaPlotagem.controls.speedOptions.verySlow'), valor: 1 },
                { texto: this.$t('mapaPlotagem.controls.speedOptions.slow'), valor: 2 },
                { texto: this.$t('mapaPlotagem.controls.speedOptions.medium'), valor: 3 },
                { texto: this.$t('mapaPlotagem.controls.speedOptions.fast'), valor: 4 },
                { texto: this.$t('mapaPlotagem.controls.speedOptions.veryFast'), valor: 5 }]
        },
        navegaPosicaoPosteriorDisabled() {
            let posicoesLinha = this.idLinhaSelected ? this.posicoesCarro.filter((p) => p.id_linha === this.idLinhaSelected) : this.posicoesCarro;
            return this.indexPosicaoClicked === posicoesLinha.length - 1;
        },
        navegaPosicaoAnteriorDisabled() {
            let posicoesLinha = this.idLinhaSelected ? this.posicoesCarro.filter((p) => p.id_linha === this.idLinhaSelected) : this.posicoesCarro;
            return this.indexPosicaoClicked === 0 || this.indexPosicaoClicked === this.posicoesCarro.findIndex((p) => p.dt_posicao == posicoesLinha[0].dt_posicao);
        },
        startReplayDisabled() {
            let posicoesLinha = this.idLinhaSelected ? this.posicoesCarro.filter((p) => p.id_linha === this.idLinhaSelected) : this.posicoesCarro;
            return this.playing || this.indexPosicaoClicked === posicoesLinha.length - 1;
        },
        stopReplayDisabled() {
            return !this.playing;
        },
        sincronizarDisabled() {
            return this.idVeiculo.length !== 2;
        },
        posicoesCarroFiltered() {
            if (this.indexPosicaoClicked !== null) {
                if (this.indexPosicaoSincronizada !== null) {
                    return [this.posicoesCarro[this.indexPosicaoClicked], this.posicoesCarro[this.indexPosicaoSincronizada]];
                }
                return [this.posicoesCarro[this.indexPosicaoClicked]];
            }

            // Overview: sample dense tracks so Leaflet/Vue do not freeze on thousands of markers.
            const positions = this.samplePosicoesForMap(this.posicoesCarro);
            const firstAndLast = [];
            const vehicleIds = [...new Set(positions.map((p) => p.id_carro))];

            vehicleIds.forEach((vehicleId) => {
                const vehiclePositions = positions.filter((p) => p.id_carro === vehicleId);
                if (vehiclePositions.length > 0) {
                    firstAndLast.push(vehiclePositions[0]);
                    if (vehiclePositions.length > 1) {
                        firstAndLast.push(vehiclePositions[vehiclePositions.length - 1]);
                    }
                }
            });

            const regular = positions.filter(
                (p) => !firstAndLast.find(
                    (fl) => fl.dt_posicao === p.dt_posicao && fl.id_carro === p.id_carro
                )
            );

            return [...regular, ...firstAndLast];
        },
        today() {
            let year, month, day;
            [day, month, year] = new Date().toLocaleDateString().split("/")
            return year + month + day;
        },
        filteredRotas() {
            let rts = this.rotas;

            if (this.idLinhaSelected) {
                rts = rts.filter((r) => r.id_linha == this.idLinhaSelected);
            }

            if (!this.showIda) {
                rts = rts.filter((r) => r.id_sentido != 1);
            }

            if (!this.showVolta) {
                rts = rts.filter((r) => r.id_sentido != 2);
            }

            if (!this.showDeslocamento) {
                rts = rts.filter((r) => r.id_tipo_rota != 2);
            }

            return rts;
        },
        cercasCirculares() {
            return this.cercasFiltered.filter((c) => c.is_circular == 1);
        },
        cercasGeojson() {
            return this.cercasFiltered.filter((c) => c.is_circular == 0);
        },
        cercasCircularesIda() {
            return this.cercasCirculares.filter((c) => c.id_sentido == 1 || c.id_sentido == -1);
        },
        cercasCircularesVolta() {
            return this.cercasCirculares.filter((c) => c.id_sentido == 2 || c.id_sentido == -1);
        },
        cercasGeojsonIda() {
            return this.cercasGeojson.filter((c) => c.id_sentido == 1 || c.id_sentido == -1);
        },
        cercasGeojsonVolta() {
            return this.cercasGeojson.filter((c) => c.id_sentido == 2 || c.id_sentido == -1);
        },
        cercasFiltered() {
            let r = this.cercas.filter((c) => c.codigo_cerca !== "POI");
            r.map((c) => {
                if (c.id_linha === this.idLinhaSelected) {
                    c.visible = true;
                } else {
                    c.visible = false;
                }
            });
            return r;
        }
    },
    mounted() {
        const platform = new window.H.service.Platform({
            apikey: this.apikey,
        });
        this.platform = platform;
        this.initialize();
    },
    methods: {
        initialize() {
            this.currentCenter = this.center;
            this.getParametrosControle();
            if (this.posicoes && this.posicoes.length) {
                this.posicoesCarro = this.annotatePosicoes(this.posicoes);
            }
            if (this.idVeiculo) {
                this.populaPosicoesPorCarro(this.dti, this.dtf);
                this.populaBilhetagensPorCarro(this.dti, this.dtf)
            }
        },
        getParametrosControle() {
            let dtf = DateUtils.getDateSQLFormatted(new Date());
            let dti = new Date();
            dti.setDate(1);
            dti.setHours(0, 0, 0);
            dti = DateUtils.getDateSQLFormatted(dti);

            apiController.request(apiController.endpoints.getallParametroscontroledata, {
                params: { dti, dtf },
                onSuccess: (response) => {
                    this.parametrosControle = Object.assign({}, response.data[0]);
                    console.log(this.parametrosControle);
                },
            });
        },
        /** Max markers drawn in overview mode (replay still uses full posicoesCarro). */
        maxMapMarkers() {
            return 1000;
        },
        annotatePosicoes(rows) {
            const list = Array.isArray(rows) ? rows : [];
            const endsByVehicle = new Map();
            list.forEach((p, i) => {
                if (!p || p.id_carro == null) return;
                if (!endsByVehicle.has(p.id_carro)) {
                    endsByVehicle.set(p.id_carro, { first: i, last: i });
                } else {
                    endsByVehicle.get(p.id_carro).last = i;
                }
            });
            return list.map((p, i) => {
                const ends = p && p.id_carro != null ? endsByVehicle.get(p.id_carro) : null;
                const annotated = {
                    ...p,
                    _index: i,
                    _isFirst: !!(ends && ends.first === i),
                    _isLast: !!(ends && ends.last === i),
                };
                return Object.freeze(annotated);
            });
        },
        samplePosicoesForMap(positions) {
            const list = Array.isArray(positions) ? positions : [];
            const max = this.maxMapMarkers();
            if (list.length <= max) return list;

            const byVehicle = new Map();
            list.forEach((p) => {
                if (!p || p.id_carro == null) return;
                if (!byVehicle.has(p.id_carro)) byVehicle.set(p.id_carro, []);
                byVehicle.get(p.id_carro).push(p);
            });
            const groups = [...byVehicle.values()];
            if (groups.length === 0) return list;

            const perVehicle = Math.max(2, Math.floor(max / groups.length));
            const out = [];
            groups.forEach((group) => {
                if (group.length <= perVehicle) {
                    out.push(...group);
                    return;
                }
                out.push(group[0]);
                const middleCount = perVehicle - 2;
                if (middleCount > 0) {
                    const step = (group.length - 1) / (middleCount + 1);
                    for (let i = 1; i <= middleCount; i++) {
                        out.push(group[Math.round(i * step)]);
                    }
                }
                out.push(group[group.length - 1]);
            });
            return out;
        },
        clearProgressDialog() {
            this.mensagemProgressoDialog = "";
            this.progressoDialog = false;
        },
        populaPosicoesPorCarro(dti, dtf) {
            if (this.posicoesCarro.length === 0) {
                this.mensagemProgressoDialog = this.$t('mapaPlotagem.messages.retrievingPositions');
                this.progressoDialog = true;
                let temp = {
                    id: this.idVeiculo,
                    dti: dti,
                    dtf: dtf
                }
                apiController.request(apiController.endpoints.getPosicoesporcarrodata, {
                    data: temp,
                    onSuccess: (response) => {
                        const rows = Array.isArray(response.data) ? response.data : [];
                        this.iconCache = Object.create(null);
                        this.posicoesCarro = this.annotatePosicoes(rows);
                        // Close dialog before heavy Leaflet/Vue marker work.
                        this.clearProgressDialog();
                        if (this.posicoesCarro.length > 0) {
                            this.$nextTick(() => this.populaMapa());
                        }
                    },
                    onError: () => {
                        this.clearProgressDialog();
                    },
                });
            } else {
                this.populaMapa();
            }
        },
        populaMapa() {
            if (!this.posicoesCarro.length) {
                this.clearProgressDialog();
                return;
            }
            this.markerPosicoesVisible = true;
            const centro = Math.floor(this.posicoesCarro.length / 2);
            this.currentCenter = [
                this.posicoesCarro[centro].lat,
                this.posicoesCarro[centro].lng];
            let idlinhas = Array.from(new Set(this.posicoesCarro.map((p) => p.id_linha).filter((id) => id != null)));
            Promise.all([this.populaCercasPorLinha(idlinhas), this.populaRotasPorLinha(idlinhas)])
                .catch(() => {})
                .finally(() => {
                    this.clearProgressDialog();
                });
        },
        populaBilhetagensPorCarro(dti, dtf) {
            let temp = {
                id: this.idVeiculo,
                dti: dti,
                dtf: dtf
            }
            apiController.request(apiController.endpoints.getBilhetagensporcarrodata, {
                data: temp,
                onSuccess: (response) => {
                    this.bilhetagensCarro = [];
                    if (response.data.length > 0) {
                        this.bilhetagensCarro = response.data;
                        this.markerBilhetagensVisible = true;
                    }
                },
            });
        },
        populaRotasPorLinha(idlinhas) {
            if (!idlinhas || !idlinhas.length) {
                return Promise.resolve();
            }
            return apiController.request(apiController.endpoints.getRotasporlinha, {
                data: idlinhas,
                onSuccess: (response) => {
                    const rows = Array.isArray(response.data) ? response.data : [];
                    for (var i = 0; i < rows.length; i++) {
                        let rota = rows[i]
                        if (rota.geojson) {
                            if (typeof rota.geojson === "string") {
                                rota.geojson = JSON.parse(rota.geojson);
                            }

                            rota.style = {
                                color: "blue",
                                fillColor: "blue"
                            };
                            rota.options = {
                                onEachFeature: (feat, layer) => {
                                    layer.bindPopup(feat.properties.name);
                                }
                            };
                        }
                        this.rotas.push(rota);
                    }
                    this.showRotas = true;
                },
            });
        },
        populaCercasPorLinha(idlinhas) {
            if (!idlinhas || !idlinhas.length) {
                return Promise.resolve();
            }
            return apiController.request(apiController.endpoints.getCercasporlinha, {
                data: idlinhas,
                onSuccess: (response) => {
                    const rows = Array.isArray(response.data) ? response.data : [];
                    for (var i = 0; i < rows.length; i++) {
                        let cerca = rows[i]
                        if (cerca.geojson) {
                            if (typeof cerca.geojson === "string") {
                                cerca.geojson = JSON.parse(cerca.geojson);
                            }

                            cerca.style = {
                                color: this.lineColors[i],
                                fillColor: this.lineColors[i]
                            };
                            cerca.options = {
                                onEachFeature: (feat, layer) => {
                                    layer.bindPopup(feat.properties.name);
                                     // Add tooltip for non-circular stops to show name on hover
                                     if (cerca.is_circular == 0 && cerca.nome_cerca) {
                                        layer.bindTooltip(cerca.nome_cerca);
                                    } else if (cerca.is_circular == 0 && feat.properties.name) {
                                        layer.bindTooltip(feat.properties.name);
                                    }
                                }
                            };
                        }

                        this.cercas.push(cerca);
                    }
                    this.populaLinhasSelect(idlinhas)
                    this.idLinhaSelected = idlinhas[0];
                    this.populaPontosInteresse()
                    this.showCercas = true;
                },
            });
        },
        populaLinhasSelect(idlinhas) {
            this.linhasSelect = (idlinhas || []).map((id) => {
                const match = this.posicoesCarro.find((p) => p.id_linha === id);
                return {
                    id_linha: id,
                    cod_linha: (match && match.cod_linha) || String(id),
                };
            });
        },
        drawerTransition() {
            if (!this.showingDrawer) {
                this.indexPosicaoClicked = null;
            }
        },
        async exportPDF(div) {
            this.mensagemProgressoDialog = this.$t('mapaPlotagem.messages.exportingPdf');
            this.progressoDialog = true;
            await domtoimage
                .toPng(div)
                .then(function (dataUrl) {
                    var img = new Image(800, 400);
                    img.src = dataUrl;
                    const doc = new jsPDF({
                        orientation: "l",
                        //unit: "cm",
                        //format: [300, 700],
                        format: "a4",
                    });
                    doc.addImage(img, "JPEG", 5, 5, 285, 195);
                    const date = new Date();
                    const filename =
                        "plotagem_" +
                        date.getFullYear() +
                        ("0" + (date.getMonth() + 1)).slice(-2) +
                        ("0" + date.getDate()).slice(-2) +
                        ("0" + date.getHours()).slice(-2) +
                        ("0" + date.getMinutes()).slice(-2) +
                        ("0" + date.getSeconds()).slice(-2) +
                        ".pdf";
                    doc.save(filename);
                })
                .catch((error) => {
                    EventBus.$emit('show-error', { error });
                });
            this.mensagemProgressoDialog = "";
            this.progressoDialog = false;
        },
        updateEnderecoNotificacao(id) {
            apiController.request(apiController.endpoints.updateEndereconotificacao, {
                data: {
                    id_notificacao: id,
                    endereco: this.itemEndereco,
                },
            });
        },
        obterEnderecoMarkerPlotagem(lat, lng, idnotificacao) {
            this.showProgressEndereco = true;
            const url = RevGeoCodeBaseUrl +
                "latitude=" + lat +
                "&longitude=" + lng +
                "&access_token=" + GeoCodeApiKey;
            axios
            .get(url)
            .then((response) => {
                if (response.data.features.length === 0) {
                    EventBus.$emit('show-alert', { mensagem: 'Endereço não encontrado!', tipo: 'warning' });
                } else {
                    const item = response.data.features[0].properties.context;
                    this.itemEndereco[0] = Object.assign({}, {
                        street: item.street?.name,
                        houseNumber: item.address?.address_number,
                        district: item.locality?.name,
                        city: item.place?.name,
                        stateCode: item.region?.region_code,
                        postalCode: item.postcode?.name,
                    });
                    if (idnotificacao != null) {
                        this.updateEnderecoNotificacao(idnotificacao);
                    }
                }
                this.showProgressEndereco = false;
            })
            .catch((e) => {
                    this.itemEndereco = [
                        {
                            street: "",
                            houseNumber: "",
                            district: "",
                            city: "",
                            stateCode: "",
                            postalCode: "",
                        }];
                    EventBus.$emit('show-alert', { mensagem: this.$t('mapaPlotagem.messages.noAddressFound'), tipo: 'warning' });
                    EventBus.$emit('show-error', { error: e });
                    this.showProgressEndereco = false;
                });
        },
        navegaPosicoes(direcao) {
            if (direcao === "posterior") {
                if (this.indexPosicaoClicked < this.posicoesCarro.length - 1 && this.posicoesCarro[this.indexPosicaoClicked].id_carro === this.posicoesCarro[this.indexPosicaoClicked + 1].id_carro) {
                    this.indexPosicaoClicked += 1;
                }
                if (this.indexPosicaoSincronizada !== null && this.indexPosicaoSincronizada < this.posicoesCarro.length - 1 && this.posicoesCarro[this.indexPosicaoSincronizada].id_carro === this.posicoesCarro[this.indexPosicaoSincronizada + 1].id_carro) {
                    this.indexPosicaoSincronizada += 1;
                }
            } else {
                if (this.indexPosicaoClicked > 0 && this.posicoesCarro[this.indexPosicaoClicked].id_carro === this.posicoesCarro[this.indexPosicaoClicked - 1].id_carro) {
                    this.indexPosicaoClicked -= 1;
                }

                if (this.indexPosicaoSincronizada !== null && this.indexPosicaoSincronizada > 0 && this.posicoesCarro[this.indexPosicaoSincronizada].id_carro === this.posicoesCarro[this.indexPosicaoSincronizada - 1].id_carro) {
                    this.indexPosicaoSincronizada -= 1;
                }
            }
            this.showDetalhesPosicoes(this.indexPosicaoClicked)
        },
        play() {
            return new Promise(resolve => {
                this.navegaPosicoes('posterior');
                let posicoesLinha = this.idLinhaSelected ? this.posicoesCarro.filter((p) => p.id_linha === this.idLinhaSelected) : this.posicoesCarro;
                if (this.indexPosicaoClicked === posicoesLinha.length - 1) this.playing = false;
                setTimeout(() => resolve(), 2000 / this.playSpeed);
            });
        },
        async startReplay() {
            this.playing = true;
            let posicoesLinha = this.idLinhaSelected ? this.posicoesCarro.filter((p) => p.id_linha === this.idLinhaSelected) : this.posicoesCarro;
            while (this.playing && this.indexPosicaoClicked < posicoesLinha.length - 1) {
                await this.play()
            }
        },
        stopReplay() {
            this.playing = false;
        },
        showDetalhesPosicoes(index) {
            this.indexPosicaoClicked = index;
            this.ultimaPosicaoClicked = index;
            this.itemEndereco = [
                {
                    street: "",
                    houseNumber: "",
                    district: "",
                    city: "",
                    stateCode: "",
                    postalCode: "",
                }];
            this.posicaoMarkerClicked = null;
            this.posicaoMarkerClicked = this.posicoesCarro[index];
            this.currentCenter = [this.posicoesCarro[index].lat, this.posicoesCarro[index].lng];
            this.showingDrawer = true;
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        onMapPlotagemResize() {
            this.$refs.mapPlotagem.mapObject.invalidateSize();
        },
        getMarkerRotation(veiculo) {
            if (veiculo && (veiculo._isFirst || veiculo._isLast)) {
                return 0;
            }
            return parseInt(veiculo && veiculo.rumo, 10) || 0;
        },
        getZIndexOffset(veiculo) {
            if (veiculo && veiculo._isFirst) return 10000;
            if (veiculo && veiculo._isLast) return 9000;
            return 100;
        },
        getOriginalIndex(position) {
            if (position && position._index != null) {
                return position._index;
            }
            return this.posicoesCarro.findIndex((p) =>
                p.dt_posicao === position.dt_posicao &&
                p.id_carro === position.id_carro &&
                p.lat === position.lat &&
                p.lng === position.lng
            );
        },
        getCachedDivIcon(cacheKey, factory) {
            if (!this.iconCache[cacheKey]) {
                this.iconCache[cacheKey] = factory();
            }
            return this.iconCache[cacheKey];
        },
        getIconPosicao(veiculo) {
            const isFirstPosition = !!(veiculo && veiculo._isFirst);
            const isLastPosition = !!(veiculo && veiculo._isLast);

            let width = "20";
            let height = "20";
            let color = "#01579B";
            let flagColor = "#FF9800";
            let flagStroke = "#F57C00";

            if (isFirstPosition) {
                width = "30";
                height = "30";
                color = "#027BD7";
                flagColor = "#027BD7";
                flagStroke = "#01579B";
            } else if (isLastPosition) {
                width = "30";
                height = "30";
                color = "#164569";
                flagColor = "#01579B";
                flagStroke = "#0D2A3D";
            }
            if (this.idVeiculo.length > 1) {
              if (veiculo.id_carro === this.idVeiculo[0]) {
                color = "#01579B";
                flagColor = "#9C0602";
                flagStroke = "#3D110F";
                if (isFirstPosition) {
                  color = "#027BD7";
                  flagColor = "#027BD7";
                  flagStroke = "#01579B";
                }
                if (isLastPosition) {
                  color = "#164569";
                  flagColor = "#01579B";
                  flagStroke = "#0D2A3D";
                }
              } else if (veiculo.id_carro === this.idVeiculo[1]) {
                color = "#999C02";
                if (isFirstPosition) {
                  color = "#D4D702";
                  flagColor = "#D4D702";
                  flagStroke = "#999C02";
                }
                if (isLastPosition) {
                  color = "#5B5C18";
                  flagColor = "#999C02";
                  flagStroke = "#3D3E10";
                }
              } else {
                color = "#9C0602"
                if (isFirstPosition) {
                  color = "#D70902";
                  flagColor = "#D70902";
                  flagStroke = "#9C0602";
                }
                if (isLastPosition) {
                  color = "#5C1A18";
                  flagColor = "#9C0602";
                  flagStroke = "#3D110F";
                }

              }
            }

            if (isFirstPosition || isLastPosition) {
                const flagKey = `flag-${flagColor}-${flagStroke}`;
                return this.getCachedDivIcon(flagKey, () => L.divIcon({
                    className: "my-custom-pin",
                    html: `<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path d="M10 36V8H12V10H28L26 16L28 22H12V36H10Z" fill="${flagColor}" stroke="${flagStroke}" stroke-width="1.5"/>
                            </g>
                            </svg>`,
                    iconAnchor: [12, 40]
                }));
            }

            let selected = false;
            if (this.indexPosicaoClicked !== null && this.posicoesCarro[this.indexPosicaoClicked]
                && this.posicoesCarro[this.indexPosicaoClicked].dt_posicao === veiculo.dt_posicao
                && this.posicoesCarro[this.indexPosicaoClicked].id_carro === veiculo.id_carro) {
                width = "30";
                height = "30";
                color = "green";
                selected = true;
            }

            if (this.ultimaPosicaoClicked !== null && this.posicoesCarro[this.ultimaPosicaoClicked]
                && this.posicoesCarro[this.ultimaPosicaoClicked].dt_posicao === veiculo.dt_posicao
                && this.posicoesCarro[this.ultimaPosicaoClicked].id_carro === veiculo.id_carro) {
                color = "green";
                selected = true;
            }

            const pinKey = `pin-${width}-${height}-${color}-${selected ? 1 : 0}`;
            return this.getCachedDivIcon(pinKey, () => L.divIcon({
                className: "my-custom-pin",
                html: `<svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                        <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                        <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>`,
                iconAnchor: [15, 15]
            }));
        },
        getIconBilhetagem() {
            return this.getCachedDivIcon('bilhetagem', () => L.divIcon({
                className: "my-custom-pin",
                html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="32px"><title>Bilhetagem</title><path fill="#FF0000" d="M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z" /></svg>',
            }));
        },
        latLng(lat, lng) {
            const latN = typeof lat === 'number' ? lat : parseFloat(lat);
            const lngN = typeof lng === 'number' ? lng : parseFloat(lng);
            if (Number.isFinite(latN) && Number.isFinite(lngN) && latN !== 0) {
                return L.latLng(latN, lngN);
            }
            return L.latLng(-22.88746, -43.29185);
        },
        populaPontosInteresse() {
            this.pontosInteresse = this.cercas.filter((c) => c.codigo_cerca === 'POI' && c.id_linha === this.idLinhaSelected);
            this.showPontosInteresse = true;
        },
        linhaChanged() {
            this.showCercas = true;
            this.populaPontosInteresse()
        },
        sincronizarPosicoes() {
            let posicoesOutroVeiculo = this.posicoesCarro
                .filter((p) => p.id_carro != this.posicoesCarro[this.indexPosicaoClicked].id_carro)
                .map((p) => {
                    return {
                        dt_diff: Math.abs(new Date(p.dt_posicao) - new Date(this.posicoesCarro[this.indexPosicaoClicked].dt_posicao)),
                        index: this.posicoesCarro.findIndex((e) => e.dt_posicao === p.dt_posicao)
                    }
                });
            let posicaoMaisProxima = posicoesOutroVeiculo.reduce((prev, curr) => prev.dt_diff < curr.dt_diff ? prev : curr);
            this.indexPosicaoSincronizada = posicaoMaisProxima.index;
        },
        async getAddressFromPosition(requests, positions) {
            const pos = [];
            const url = GeoCodeBatchUrl +
                "access_token=" + GeoCodeApiKey;
            try {
                registrarChamadaApiExterna('MAPBOX', 'GEOCODE_REVERSE', 1, this.token);
                const res = await axios.post(url, requests);

                if (res.status !== 200) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('address.notPossibleGet'), tipo: 'error' });
                    return [];
                }

                if (res.data.batch.length !== 0) {
                    const batch = res.data.batch;
                    for (let i=0; i < batch.length; i++) {
                        const item = batch[i].features[0]?.properties.context;
                        if (item) {
                            pos.push({
                            data: positions[i].dt_posicao_extenso, 
                            veiculo: positions[i].numero_ordem,
                            lat: positions[i].lat,
                            lng: positions[i].lng, 
                            velocidade: positions[i].velocidade, 
                            rua: item.street?.name,
                            numero: item.address?.address_number,
                            bairro: item.locality?.name,
                            cidade: item.place?.name,
                            uf: item.region?.region_code,
                            cep: item.postcode?.name, 
                            observacoes: ""
                        });
                        } else {
                            pos.push({
                                data: positions[i].dt_posicao_extenso, 
                                veiculo: positions[i].numero_ordem,
                                lat: positions[i].lat,
                                lng: positions[i].lng, 
                                velocidade: positions[i].velocidade, 
                                rua: "",
                                numero: "",
                                bairro: "",
                                cidade: "",
                                uf: "",
                                cep: "", 
                                observacoes: this.$t('address.notPossibleGet')
                            });
                        }
                    }
                    return pos;
                } else {
                    EventBus.$emit('show-alert', { mensagem: this.$t('address.notPossibleGet'), tipo: 'error' });
                    return [];
                }
            } catch (e) {
                EventBus.$emit('show-alert', { mensagem: this.$t('address.notPossibleGet'), tipo: 'error' });
                EventBus.$emit('show-error', { error: e });
                return [];
            }
        },
        async getAddressLoop(positions) {
            // const res = [];
            const req = [];
            // const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
            for (let i = 0; i < positions.length; i++) {
                const request = {
                    types: ["address"],
                    latitude: positions[i].lat,
                    longitude: positions[i].lng
                }
                // await delay(1000);
                req.push(request);
            }

            const res = await this.getAddressFromPosition(req, positions);

            return res;
        },
        async exportTable() {
            this.mensagemProgressoDialog = this.$t('mapaPlotagem.generatingRel')
            this.progressoDialog = true;
            let posicoesTabela = await this.getAddressLoop(this.posicoesCarro);
            if (posicoesTabela.length > 0) {
                let parametro = {
                    dt_registro: DateUtils.getDateSQLFormatted(new Date()),
                    valor: posicoesTabela.length
                }
                apiController.request(apiController.endpoints.updateChamadashereapi, {
                    data: parametro,
                    onSuccess: () => {
                        this.getParametrosControle();
                    },
                });

                posicoesTabela.sort((a, b) => {
                    if (a.data < b.data) {
                        return -1;
                    }

                    if (a.data > b.data) {
                        return 1;
                    }

                    return 0;
                });
                let csvContent = "data:text/csv;charset=utf-8," + Object.keys(posicoesTabela[0]).join(';') + "\n" + posicoesTabela.map((p) => {
                    return Object.values(p).join(';');
                }).join('\n');
                let date = new Date();
                let encodedUri = encodeURI(csvContent);
                let link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", `relplotagem${DateUtils.getDateSQLFormatted(date)}.csv`);
                document.body.appendChild(link);
                link.click();

                const doc = new jsPDF({
                    orientation: "l",
                    unit: "cm",
                    //format: [300, 700],
                    format: "a4",
                });
                doc.text(this.$t('mapaPlotagem.docTitle'), 1.5, 1.5);
                doc.text(date.toLocaleString(), 23.0, 1.5);
                doc.setFontSize(10);
                doc.setLineWidth(0.01);
                doc.line(1.4, 1.8, 29.0, 1.8);
                doc.text(`${posicoesTabela[0].data} - ${posicoesTabela[posicoesTabela.length - 1].data}`, 1.5, 2.5);

                let filteredHeaders = Object.keys(posicoesTabela[0]);
                const tableContent = posicoesTabela.map((p) => {
                    return Object.values(p);
                });

                autoTable(doc, {
                    styles: { fontSize: 8 },
                    head: [filteredHeaders],
                    body: tableContent,
                    startY: 3.0,
                    pageBreak: 'auto',
                    horizontalPageBreak: true,
                })

                const fileFullName =
                    "relplotagem" +
                    date.getFullYear() +
                    ("0" + (date.getMonth() + 1)).slice(-2) +
                    ("0" + date.getDate()).slice(-2) +
                    ("0" + date.getHours()).slice(-2) +
                    ("0" + date.getMinutes()).slice(-2) +
                    ("0" + date.getSeconds()).slice(-2) +
                    ".pdf";
                doc.save(fileFullName);
            }
                this.progressoDialog = false;
            }
        }
    }
</script>
<style lang="">

</style>